var _circle, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayconiq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF4785"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9125_25912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 4,
    height: 6
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78683 13.9412L5.64481 12.7881C5.54326 12.6385 5.46962 12.4791 5.4216 12.3155C5.37359 12.1519 5.35218 11.984 5.35574 11.8177C5.36677 11.2636 5.65584 10.7231 6.17719 10.3992L4.9726 8.62048C3.11365 9.77479 2.58192 12.1613 3.78683 13.9412Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9125_25912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98193 15.0243H7.33688V7.5376H1.98193V15.0243Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9125_25912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 4,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6364 10.9094V10.9097C18.8985 11.2966 18.9874 11.7578 18.8868 12.2089C18.7863 12.6603 18.5082 13.0469 18.104 13.2981L19.3083 15.0777C20.2092 14.5181 20.8285 13.6568 21.0524 12.6518C21.0842 12.5094 21.1062 12.3664 21.1211 12.2237C21.1319 12.124 21.1383 12.0244 21.1406 11.9247C21.1409 11.9153 21.1416 11.9059 21.1416 11.8965C21.1529 11.1427 20.9323 10.4026 20.4944 9.75635L18.6364 10.9094Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9125_25912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9443 16.1605H22.3022V8.67322H16.9443V16.1605Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9125_25912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 8,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.97266 8.62078L6.17724 10.3992V10.3995C6.47928 10.2117 6.81928 10.1217 7.15506 10.1217C7.74681 10.1217 8.32688 10.3995 8.67207 10.9097C8.93388 11.2963 9.02309 11.7577 8.9222 12.2085C8.83428 12.603 8.6114 12.9478 8.28697 13.1962L11.127 11.2415C11.0397 10.7185 10.8399 10.2138 10.5297 9.75601C9.9464 8.89376 9.04678 8.30024 7.99694 8.08574C7.71534 8.02818 7.43147 8 7.14987 8C6.3826 8 5.63124 8.21087 4.97266 8.62078Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9125_25912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81299 14.2793H12.2869V6.91687H3.81299V14.2793Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9125_25912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 10,
    width: 7,
    height: 6
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0003 10.4961L16.1414 10.3992C16.0921 10.4295 16.0454 10.4619 16.0003 10.4961ZM13.1558 12.4545C13.2404 12.9695 13.4357 13.4758 13.7504 13.9415C14.5193 15.0767 15.8112 15.6951 17.1287 15.6951C17.8771 15.6951 18.6343 15.4951 19.3075 15.0776L18.1032 13.298C17.699 13.5497 17.2179 13.6337 16.7458 13.5379C16.2748 13.4416 15.8709 13.1753 15.6084 12.7881C15.0997 12.0358 15.2811 11.043 16.0003 10.4961L13.1558 12.4545Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9125_25912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9961 16.7782H20.4675V9.31604H11.9961V16.7782Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_9125_25912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 18,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8933 8.6489L14.6597 8.80948L11.1267 11.2414L8.28671 13.1962C8.23967 13.2325 8.19035 13.2664 8.1391 13.2983C8.04599 13.3558 7.94898 13.4028 7.85003 13.4425C7.12884 13.73 6.28339 13.537 5.77631 12.9571C5.72992 12.9035 5.68515 12.8477 5.6446 12.7881L3.78662 13.9415C4.37026 14.8037 5.26989 15.3969 6.3194 15.6114C6.38948 15.6257 6.45955 15.6381 6.52963 15.649C6.59776 15.6593 6.66653 15.6678 6.73466 15.675C6.73629 15.6754 6.73758 15.6754 6.73921 15.6757C6.87936 15.6896 7.01918 15.6969 7.15901 15.6969C7.93017 15.6969 8.69321 15.4802 9.38553 15.0494C9.38748 15.0482 9.38943 15.047 9.39137 15.0455L9.61944 14.8888L13.156 12.4545L16.1413 10.3992C16.1868 10.371 16.2332 10.3458 16.2802 10.3219C16.2938 10.3149 16.3078 10.3083 16.3214 10.3019C16.3581 10.2843 16.396 10.268 16.4336 10.2528C16.4457 10.248 16.4577 10.2428 16.4697 10.2386C16.5196 10.2198 16.5702 10.2031 16.6215 10.1889C16.626 10.1874 16.6309 10.1865 16.6354 10.1853C16.6828 10.1725 16.7302 10.1622 16.7785 10.1531C16.7902 10.151 16.8015 10.1489 16.8135 10.1471C16.8606 10.1392 16.9086 10.1328 16.9566 10.1289C16.9621 10.1283 16.968 10.1274 16.9735 10.1268C17.0215 10.1231 17.0702 10.121 17.1185 10.121C17.1234 10.121 17.1289 10.1213 17.1341 10.1213C17.1691 10.1216 17.2042 10.1247 17.2389 10.1268C17.2645 10.1286 17.2905 10.1289 17.3161 10.1316C17.3771 10.138 17.4381 10.1471 17.4987 10.1595C17.5575 10.1713 17.6152 10.1862 17.672 10.2031C17.7255 10.2195 17.7777 10.2386 17.829 10.2592C17.8452 10.2658 17.8611 10.2737 17.877 10.281C17.9114 10.2961 17.9458 10.3116 17.9789 10.3286C17.9974 10.3383 18.0149 10.3483 18.0327 10.3586C18.0629 10.3752 18.0924 10.3925 18.1216 10.411C18.1395 10.4225 18.1567 10.4343 18.1742 10.4461C18.2027 10.4658 18.23 10.4861 18.2569 10.5067C18.2735 10.5191 18.289 10.5322 18.3053 10.5452C18.3325 10.5685 18.3591 10.5924 18.3854 10.617C18.3987 10.6297 18.4126 10.6418 18.425 10.6552C18.4545 10.6849 18.4827 10.7158 18.51 10.7476C18.5184 10.757 18.5272 10.766 18.5353 10.7754C18.5706 10.8185 18.6044 10.8627 18.6358 10.9094L20.4938 9.75625V9.75595C20.0562 9.10942 19.4407 8.61376 18.7173 8.31624C18.4765 8.21687 18.2235 8.13931 17.961 8.08599C17.6824 8.02933 17.4014 8.00085 17.1221 8.00085C16.3496 8.00085 15.5869 8.21748 14.8933 8.6489Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_9125_25912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62695 16.7801H21.6535V6.91785H2.62695V16.7801Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_9125_25912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 4,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78683 13.9412L5.64481 12.7881C5.54326 12.6385 5.46962 12.4791 5.4216 12.3155C5.37359 12.1519 5.35218 11.984 5.35574 11.8177C5.36677 11.2636 5.65584 10.7231 6.17719 10.3992L4.9726 8.62048C3.11365 9.77479 2.58192 12.1613 3.78683 13.9412Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_9125_25912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98193 15.0243H7.33688V7.5376H1.98193V15.0243Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_9125_25912",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 4,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6364 10.9094V10.9097C18.8985 11.2966 18.9874 11.7578 18.8868 12.2089C18.7863 12.6603 18.5082 13.0469 18.104 13.2981L19.3083 15.0777C20.2092 14.5181 20.8285 13.6568 21.0524 12.6518C21.0842 12.5094 21.1062 12.3664 21.1211 12.2237C21.1319 12.124 21.1383 12.0244 21.1406 11.9247C21.1409 11.9153 21.1416 11.9059 21.1416 11.8965C21.1529 11.1427 20.9323 10.4026 20.4944 9.75635L18.6364 10.9094Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_9125_25912)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9443 16.1605H22.3022V8.67322H16.9443V16.1605Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayconiq);
export default __webpack_public_path__ + "static/media/payconiq.4913974f80c7f2df74d22e53bb6bab4d.svg";
export { ForwardRef as ReactComponent };